import { IMAGE_CONFIG } from '@angular/common';
import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withEnabledBlockingInitialNavigation, withHashLocation, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';

import { registerLocaleData } from '@angular/common';
import localeEsPY from '@angular/common/locales/es-PY';
import { provideServiceWorker } from '@angular/service-worker';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { nfcAuthInterceptor } from './core/interceptors/nfc-auth.interceptor';
import { FormatogsPipe } from './shared/pipes/formatogs.pipe';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

registerLocaleData(localeEsPY, 'es-PY');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),

        provideRouter(
            routes,
            withRouterConfig({
                onSameUrlNavigation: 'ignore'
            }),
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled'
            }),
            withEnabledBlockingInitialNavigation(),
            withViewTransitions({ skipInitialTransition: true }), // ⚠️ Comentar esto si el error persiste
            withHashLocation()
        ),

        // ✅ Un solo provideHttpClient con todo junto
        provideHttpClient(withFetch(), withInterceptors([authInterceptor, nfcAuthInterceptor])),

        provideAnimations(),
        {
            provide: IMAGE_CONFIG,
            useValue: {
                disableImageSizeWarning: true,
                disableImageLazyLoadWarning: true
            }
        },
        providePrimeNG({
            theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } }
        }),
        MessageService,
        DialogService,
        FormatogsPipe,
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        })
    ]
};
